<tc-auto-assigned-summary
        (closePopUp)="onClosePopup($event)"
        [assignedResources]="assignedResources">
</tc-auto-assigned-summary>

